import apiSlice from "./apiSlice";

const userApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getUserByEmail: builder.query({
            query: (email) => ({
                url: `account`,
                params: { email },              
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            providesTags: ["UserByEmail"],
        }),
    }),
});

export const { useGetUserByEmailQuery } = userApiSlice;
